(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function () {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector('.product-recommendations');
    if (productRecommendationsSection === null) {
      return;
    }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open('GET', productRecommendationsSection.dataset.url);
    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement('div');
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector('.product-recommendations').innerHTML;
        theme.ProductBlockManager.loadImages(productRecommendationsSection);
        theme.initAnimateOnScroll();
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-product-info-with-qa"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const resizeOpenAccordions = () => {
      window.document.querySelectorAll('.sh-product-info-with-qa details[data-qa-item][open]').forEach((item) => {
        const c = item.querySelector('[data-qa-content]');
        if (c) c.style.maxHeight = `${c.scrollHeight}px`;
      });
    };

    window.addEventListener('resize', resizeOpenAccordions, { passive: true });

    const bindOverviewWrap = (wrap) => {
      if (wrap.dataset.shPqaOverviewBound === '1') return;
      wrap.dataset.shPqaOverviewBound = '1';

      const content = wrap.querySelector('[data-overview-content]');
      const toggle = wrap.querySelector('[data-overview-toggle]');
      const fade = content.querySelector('[data-overview-fade]');

      if (!content || !toggle) return;

      const setFade = (opacity, instant) => {
        if (!fade) return;
        if (instant) {
          fade.style.transition = 'none';
          fade.style.opacity = String(opacity);
          void fade.offsetHeight;
          fade.style.removeProperty('transition');
        } else {
          fade.style.removeProperty('transition');
          fade.style.opacity = String(opacity);
        }
      };

      const moreText = wrap.dataset.overviewShowMoreText || 'Show all overviews';
      const lessText = wrap.dataset.overviewShowLessText || 'Show less';

      /** Collapse matches accordion `.sh-product-info-with-qa__content`; expand is longer for taller overview text */
      const overviewCollapseMs = 320;
      const overviewExpandMs = 480;
      const overviewEaseCollapse = 'cubic-bezier(0.22, 1, 0.36, 1)';
      const overviewEaseExpand = 'cubic-bezier(0.25, 1, 0.3, 1)';

      const measureOverviewClone = (collapsed) => {
        const clone = content.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('data-overview-content');
        clone.setAttribute('aria-hidden', 'true');
        const rectW = Math.round(content.getBoundingClientRect().width);
        const offsetW = content.offsetWidth;
        const wrapW = wrap.offsetWidth;
        const w = Math.max(rectW || 0, offsetW || 0, wrapW || 0, 280);
        clone.style.cssText = `
          position: absolute !important;
          left: -99999px !important;
          top: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
          width: ${w}px !important;
          max-height: none !important;
          transition: none !important;
        `;
        if (collapsed) {
          clone.classList.add('sh-product-info-with-qa__overview--collapsed');
        } else {
          clone.classList.remove('sh-product-info-with-qa__overview--collapsed');
        }
        wrap.appendChild(clone);
        const h = collapsed ? clone.offsetHeight : clone.scrollHeight;
        clone.remove();
        return Math.ceil(h);
      };

      const clearOverviewInlineMotion = () => {
        content.style.maxHeight = '';
        content.style.transition = '';
        content.style.opacity = '';
        content.style.overflow = '';
        content.style.willChange = '';
      };

      const overviewTransitionExpand = () =>
        `max-height ${overviewExpandMs}ms ${overviewEaseExpand}`;

      const overviewTransitionCollapse = () =>
        `max-height ${overviewCollapseMs}ms ${overviewEaseCollapse}`;

      const evaluateOverview = () => {
        if (content.dataset.shPqaOvAnim === '1') return;
        if (toggle.getAttribute('aria-expanded') === 'true') return;

        content.classList.add('sh-product-info-with-qa__overview--collapsed');
        void content.offsetHeight;
        const clampedHeight = Math.round(content.getBoundingClientRect().height);

        content.classList.remove('sh-product-info-with-qa__overview--collapsed');
        void content.offsetHeight;
        const fullHeight = Math.ceil(content.scrollHeight);

        const shouldToggle = fullHeight > clampedHeight + 6;

        if (shouldToggle) {
          toggle.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = moreText;
          content.classList.add('sh-product-info-with-qa__overview--collapsed');
          setFade(1, true);
          clearOverviewInlineMotion();
        } else {
          toggle.setAttribute('hidden', '');
          content.classList.remove('sh-product-info-with-qa__overview--collapsed');
          toggle.textContent = moreText;
          setFade(0, true);
          clearOverviewInlineMotion();
        }
      };

      const runEvaluateSoon = () => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => evaluateOverview());
        });
      };

      runEvaluateSoon();
      window.setTimeout(evaluateOverview, 0);
      window.setTimeout(evaluateOverview, 120);
      window.setTimeout(evaluateOverview, 500);

      const fonts = document.fonts;
      if (fonts && fonts.ready && typeof fonts.ready.then === 'function') {
        fonts.ready.then(runEvaluateSoon);
      }

      window.addEventListener('load', evaluateOverview, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => evaluateOverview());
        ro.observe(content);
      } else {
        window.addEventListener('resize', evaluateOverview, { passive: true });
      }

      toggle.addEventListener('click', () => {
        if (content.dataset.shPqaOvAnim === '1') return;

        if (prefersReducedMotion) {
          const isCollapsed = content.classList.contains('sh-product-info-with-qa__overview--collapsed');
          content.classList.toggle('sh-product-info-with-qa__overview--collapsed', !isCollapsed);
          setFade(isCollapsed ? 0 : 1, true);
          toggle.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');
          toggle.textContent = isCollapsed ? lessText : moreText;
          clearOverviewInlineMotion();
          return;
        }

        const collapsing = toggle.getAttribute('aria-expanded') === 'true';
        let motionDone = false;

        const applyEndState = () => {
          if (collapsing) {
            content.classList.add('sh-product-info-with-qa__overview--collapsed');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.textContent = moreText;
          } else {
            content.classList.remove('sh-product-info-with-qa__overview--collapsed');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.textContent = lessText;
          }
        };

        let safetyTimer;
        /** @type {(ev: TransitionEvent) => void} */
        let onTransitionEnd;

        const finishMotion = () => {
          if (motionDone) return;
          motionDone = true;
          try {
            window.clearTimeout(safetyTimer);
          } finally {
            if (typeof onTransitionEnd === 'function') {
              content.removeEventListener('transitionend', onTransitionEnd);
            }
            clearOverviewInlineMotion();
            delete content.dataset.shPqaOvAnim;
          }
        };

        onTransitionEnd = (ev) => {
          if (ev.target !== content) return;
          const pn = (ev.propertyName || '').toLowerCase();
          const isMaxHeight = pn === 'max-height' || pn.endsWith('max-height');
          if (!isMaxHeight) return;
          applyEndState();
          finishMotion();
        };

        const motionMs = collapsing ? overviewCollapseMs : overviewExpandMs;

        content.dataset.shPqaOvAnim = '1';
        content.style.overflow = 'hidden';
        content.style.willChange = 'max-height';

        content.addEventListener('transitionend', onTransitionEnd);

        safetyTimer = window.setTimeout(() => {
          applyEndState();
          finishMotion();
        }, motionMs + 160);

        if (collapsing) {
          const startH = content.scrollHeight;
          const endH = measureOverviewClone(true);

          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = moreText;

          setFade(1, true);
          content.style.transition = 'none';
          content.style.maxHeight = `${startH}px`;
          void content.offsetHeight;
          content.style.transition = overviewTransitionCollapse();
          window.requestAnimationFrame(() => {
            content.classList.add('sh-product-info-with-qa__overview--collapsed');
            content.style.maxHeight = `${endH}px`;
          });
        } else {
          void content.offsetHeight;
          const startH = Math.ceil(content.getBoundingClientRect().height);
          let targetH = Math.ceil(content.scrollHeight) + 24;
          const fallbackFull = measureOverviewClone(false) + 32;
          if (fallbackFull > targetH) targetH = fallbackFull;
          if (targetH <= startH) {
            targetH = Math.max(startH + 64, fallbackFull);
          }
          if (targetH <= startH) {
            applyEndState();
            finishMotion();
          } else {
            setFade(0, false);
            content.style.transition = 'none';
            content.style.maxHeight = `${startH}px`;
            void content.offsetHeight;
            content.style.transition = overviewTransitionExpand();
            window.requestAnimationFrame(() => {
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => {
                  content.style.maxHeight = `${targetH}px`;
                });
              });
            });
          }
        }
      });
    };

    const bindAccordionItems = (section) => {
      section.querySelectorAll('[data-qa-item]').forEach((item) => {
        if (item.dataset.shPqaAccBound === '1') return;
        item.dataset.shPqaAccBound = '1';

        const summary = item.querySelector('[data-qa-summary]');
        const content = item.querySelector('[data-qa-content]');
        if (!summary || !content) return;

        const setOpenHeightItem = () => {
          content.style.maxHeight = `${content.scrollHeight}px`;
        };

        /* Image/slider panels keep growing, so drop the height cap once fully open. */
        const releaseHeight = () => {
          if (!item.open) return;
          content.style.maxHeight = 'none';
        };

        const lockHeight = () => {
          content.style.maxHeight = `${content.scrollHeight}px`;
          void content.offsetHeight;
        };

        if (item.open) {
          item.setAttribute('data-pqa-open', '');
          setOpenHeightItem();
          releaseHeight();
        } else {
          content.style.maxHeight = '0px';
        }

        summary.addEventListener('click', (event) => {
          if (prefersReducedMotion) {
            /* native toggle; mirror the state so CSS hooked on the attribute still applies */
            requestAnimationFrame(() => item.toggleAttribute('data-pqa-open', item.open));
            return;
          }

          event.preventDefault();

          if (item.open) {
            item.removeAttribute('data-pqa-open');
            lockHeight();
            requestAnimationFrame(() => {
              content.style.maxHeight = '0px';
              content.style.opacity = '0';
            });

            const onCloseEnd = (closeEvent) => {
              if (closeEvent.propertyName !== 'max-height') return;
              item.open = false;
              content.removeEventListener('transitionend', onCloseEnd);
            };

            content.addEventListener('transitionend', onCloseEnd);
            return;
          }

          item.setAttribute('data-pqa-open', '');
          item.open = true;
          content.style.maxHeight = '0px';
          content.style.opacity = '0';

          const onOpenEnd = (openEvent) => {
            if (openEvent.propertyName !== 'max-height') return;
            content.removeEventListener('transitionend', onOpenEnd);
            releaseHeight();
          };
          content.addEventListener('transitionend', onOpenEnd);

          requestAnimationFrame(() => {
            content.style.maxHeight = `${content.scrollHeight}px`;
            content.style.opacity = '1';
          });
        });
      });
    };

    const bindProductQaSection = (section) => {
      section.querySelectorAll('[data-overview-wrap]').forEach(bindOverviewWrap);
      bindAccordionItems(section);
    };

    document.querySelectorAll('.sh-product-info-with-qa').forEach(bindProductQaSection);

    document.addEventListener('shopify:section:load', (event) => {
      event.target?.querySelectorAll?.('.sh-product-info-with-qa')?.forEach(bindProductQaSection);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
